import { useEffect } from 'react'
import { t } from '@lingui/core/macro'

import { useAuthStatus } from '@jotta/auth-client/useAuthStatus'
import { showToast } from '@jotta/ui/ToastProvider'
import { useBrandCode } from '@jotta/ui/useBrandTheme'
import { useVersion } from '@jotta/utils/frontendbackend'

let newVersionToastScheduled = false

export function useNewVersionToast() {
  const apiVersion = useAuthStatus().data?.version
  const version = useVersion()
  const brandCode = useBrandCode()

  const newVersion =
    Boolean(apiVersion) &&
    Boolean(version) &&
    // OBOS public file sharing on arkiv.styrerommet.no connects to the frontendbackend of the specialized OBOS app
    // which will always a different version than what the public sharing runs. So we simply disable this toast for OBOS.
    brandCode !== 'OBOS' &&
    apiVersion !== version &&
    !newVersionToastScheduled

  useEffect(() => {
    if (newVersion) {
      const toast = {
        message: t`A new version of the app is available. Please reload to update.`,
        duration: Infinity,
        actionButton: {
          label: t`Reload`,
          onClick: () => window.location.reload(),
        },
      }
      setTimeout(
        () => showToast(toast),
        30_000, // we might be in the middle of a deploy, give it some time to finish
      )
      newVersionToastScheduled = true
    }
  }, [newVersion])
}
